import React from 'react';
import Card from "./ScheduleCard";
import { useNavigate } from "react-router-dom";
import { FadeIn, FadeInUp } from "../../../shared/ui/animations";
import styles from '../schedule.module.css'; // Подключи стили, если есть

const Cards = ({ cards, onLoadMore, isLoading, lastPage, cardsPerPage=3 }) => {
    const navigate = useNavigate();

    const handleSelectGame = (gameId) => {
        navigate("/#form-section", {
            state: { gameId }
        });
    };

    return (
        <>
            {( Array.isArray(cards) ? cards : []).length > 0 ? (
                <>
                    <div>
                        {cards.map((card, index) => {
                            const delayIndex = (index) % cardsPerPage;
                            const delay = 80 * delayIndex;

                            return(
                            <FadeIn delay={delay} key={`schedule-${card.id}-${index}`}>
                                <div className={styles.card}>
                                    <Card card={card} index={index} onSelectGame={handleSelectGame} />
                                </div>
                            </FadeIn>
                        )})}
                    </div>

                    {!lastPage && (
                        <FadeIn delay={300}>
                            <div className="text-center loadBtnWrapper">
                                <button
                                    className="btn btn-green-filled"
                                    onClick={onLoadMore}
                                    disabled={isLoading}
                                >
                                    {isLoading ? (
                                        <>
                                            <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                                            <span className="ms-2">Загрузка...</span>
                                        </>
                                    ) : (
                                        "Загрузить ещё"
                                    )}
                                </button>
                            </div>
                        </FadeIn>
                    )}
                </>
            ) : (
                <FadeInUp>
                    <h2 className="text-center">Расписания нет</h2>
                </FadeInUp>
            )}
        </>
    );
};

export default Cards;
